export const getters = {
    permission: state => state.user.permission,
    menuColl: state => state.menu.menuColl,  
    systemConfig: state => state.system.version,
}
